import { LoadingOptionsListItem } from './Select.styles';

export const SelectLoadingOptionsIndicator = () => (
  <LoadingOptionsListItem>Loading more...</LoadingOptionsListItem>
);
